/**
 * TermsAndConditionsContent Component
 * Reusable component for rendering HTML terms and conditions with proper WYSIWYG styling
 */

import React from 'react';

export interface TermsAndConditionsContentProps {
  html: string;
  className?: string;
}

const TermsAndConditionsContent: React.FC<TermsAndConditionsContentProps> = ({
  html,
  className = '',
}) => {
  if (!html || html.trim().length === 0) {
    return null;
  }

  const content = { __html: html };

  return (
    <div
      className={`text-gray-700 leading-relaxed space-y-3 
        [&_p]:mb-3 [&_p]:text-sm
        [&_h1]:text-xl [&_h1]:font-bold [&_h1]:mb-3 [&_h1]:mt-4
        [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:mb-2 [&_h2]:mt-4
        [&_h3]:text-base [&_h3]:font-semibold [&_h3]:mb-2 [&_h3]:mt-3
        [&_h4]:text-sm [&_h4]:font-semibold [&_h4]:mb-2 [&_h4]:mt-3
        [&_strong]:font-bold [&_b]:font-bold
        [&_em]:italic [&_i]:italic
        [&_a]:text-blue-600 [&_a]:underline [&_a]:hover:text-blue-800
        [&_ol]:list-decimal [&_ol]:list-outside [&_ol]:pl-6 [&_ol]:mb-3
        [&_ul]:list-disc [&_ul]:list-outside [&_ul]:pl-6 [&_ul]:mb-3
        [&_li]:mb-2 [&_li]:ml-2
        [&_ol_ol]:list-[lower-alpha] [&_ol_ol]:ml-4 [&_ol_ol]:mt-2
        [&_ul_ul]:list-circle [&_ul_ul]:ml-4 [&_ul_ul]:mt-2
        [&_ul_ol]:list-decimal [&_ul_ol]:ml-4 [&_ul_ol]:mt-2
        [&_ol_ul]:list-disc [&_ol_ul]:ml-4 [&_ol_ul]:mt-2
        [&_blockquote]:border-l-4 [&_blockquote]:border-gray-300 [&_blockquote]:pl-4 [&_blockquote]:italic [&_blockquote]:my-4
        [&_hr]:my-4 [&_hr]:border-gray-300
        [&_table]:w-full [&_table]:border-collapse [&_table]:my-4
        [&_th]:border [&_th]:border-gray-300 [&_th]:px-3 [&_th]:py-2 [&_th]:bg-gray-100 [&_th]:font-semibold [&_th]:text-left
        [&_td]:border [&_td]:border-gray-300 [&_td]:px-3 [&_td]:py-2
        [&_code]:bg-gray-100 [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded [&_code]:text-xs [&_code]:font-mono
        [&_pre]:bg-gray-100 [&_pre]:p-3 [&_pre]:rounded [&_pre]:overflow-x-auto [&_pre]:my-3 ${className}`}
      dangerouslySetInnerHTML={content}
    />
  );
};

export default TermsAndConditionsContent;
